import { getUser } from "./services/authorize";
import { Navigate } from "react-router-dom"

const LoginRequire = ({children }) => {
  const auth = getUser()
  return auth ? children  : <Navigate to="/"/>
}

export default LoginRequire